
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import Message from '@/components/message.vue';
  import Dialog from '@/components/dialog.vue';
  import {
    ownBrandProductlist,
    ownBrandProductdelete,
    ownBrandProductsave
  } from "@/api/order"
  @Component({  
    name: '',
    components: {
      PageFooter,
			'slz-message': Message,
      'slz-dialog': Dialog,
    }
  })

  export default class ProductList extends Vue {
    private keywords = ''
    private tablelist:any = []
    private tableloading = false
    private pageSize = 10
    private pageNo = 1
    private total = 0
    private rowmsg:any = {}
    private delShow = false
    private editShow = false


    private mounted () {
      this.gettablelist()
    }



    private async saveEdit(){
      if(!this.rowmsg.ProductName){
        this.$message.error('请输入商品名称')
        return 
      }
      try{
        let res = await ownBrandProductsave({
          ...this.rowmsg,
          OwnBrandId:this.$route.query.Id
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.editShow = false
          this.gettablelist()
        }
      }finally{
        //
      }
    }
    private toEdit(row){
      if(row.Id){
        this.rowmsg = JSON.parse(JSON.stringify(row))
      }else{
        this.rowmsg = {
          Id:0,
          ProductName:'',
        }
      }
      this.editShow = true
    }
    private async confirmDel(){
      try{
        let res = await ownBrandProductdelete({Id:this.rowmsg.Id})
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.gettablelist()
        }
      }finally{
        //
      }
    }
    private toDel(row){
      this.rowmsg = row
      this.delShow = true
    }
    private doSearch(){
      this.pageNo = 1
      this.gettablelist()
    }
    private clearSearch(){
      this.keywords = ''
      this.doSearch()
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let res:any = await ownBrandProductlist({
          Keywords:this.keywords,
          OwnBrandId:this.$route.query.Id,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize
        })
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
    private changeCurrent(e){
      this.pageNo = e
      this.gettablelist()
    }
  }
